module.exports = __webpack_public_path__ + "assets/img/main_icon_carousel_arrow_left.44d1d2ec.svg";